import React, { Fragment, useState } from "react";
import classnames from "classnames";
import HoverIconButton from "components/HoverIconButton";
import { useFormikContext } from "formik";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import { FEATURE_GROUPS_FORM_KEYS } from "utils/constants/feature";
import ConfirmIconButton from "components/ConfirmIconButton";

const HeaderCell = ({ hidden, product }) => {
  const [hoverCell, setHoverCell] = useState(false);
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const canAdjustProductLayout = Boolean(
    get(values, FEATURE_GROUPS_FORM_KEYS.ADJUST_PRODUCT_LAYOUT)
  );

  const productIndex = values[
    FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT
  ].findIndex(({ uid }) => uid === product.id);
  const touchedProductLayout = touched[FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT];

  /**
   * Remove the product from the product layout
   */
  const removeFromLayout = () => {
    const updatedValues = cloneDeep(
      values[FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT]
    );
    updatedValues.splice(productIndex, 1);
    setFieldValue(FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT, updatedValues);
    if (!touchedProductLayout) {
      setFieldTouched(FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT, true);
    }
  };
  const isFirst = productIndex <= 0;
  const isLast =
    productIndex === values[FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT].length - 1;

  /**
   * Increment / decrement the product index
   */
  const updatePosition = (movement) => {
    const updatedValues = cloneDeep(
      values[FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT]
    );
    updatedValues.splice(productIndex, 1);
    updatedValues.splice(productIndex + movement, 0, { uid: product.id });

    setFieldValue(FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT, updatedValues);
    if (!touchedProductLayout) {
      setFieldTouched(FEATURE_GROUPS_FORM_KEYS.PRODUCT_LAYOUT, true);
    }
  };

  const actionBar = (
    <div key={product.id} className="flex flex-row justify-between w-100">
      <div className={isFirst ? "hidden" : "db"}>
        <HoverIconButton
          type="left"
          size={16}
          onClick={() => updatePosition(-1)}
        />
      </div>
      <div>
        <ConfirmIconButton
          icon="close"
          tooltip="Remove"
          size={16}
          onConfirm={removeFromLayout}
          slides={[
            {
              title: `Remove product`,
              header: `Are you sure you want to remove ${product.name} from the table?`
            }
          ]}
        />
      </div>
      <div className={isLast ? "hidden" : "db"}>
        <HoverIconButton
          type="right"
          size={16}
          onClick={() => updatePosition(1)}
        />
      </div>
    </div>
  );

  const containerProps = {
    className: classnames(
      "hairline-1 top-0 z-1 sticky bg-white bb bt br dtc-ns fw3",
      {
        dn: hidden
      }
    ),
    onMouseEnter: () => !hoverCell && setHoverCell(true),
    onMouseLeave: () => hoverCell && setHoverCell(false)
  };
  let controls = null;
  if (canAdjustProductLayout) {
    controls = (
      <Fragment>
        <div className="w-100" style={{ height: 32 }}></div>
        <div
          className="w-100 absolute left-0 bottom-0 right-0 w-100"
          style={{ height: 32 }}
        >
          {hoverCell && actionBar}
        </div>
      </Fragment>
    );
  }

  return (
    <th {...containerProps}>
      <div className="f4 f3-ns pa3 fw6 tc w-100">{product.name}</div>
      {controls}
    </th>
  );
};

const TableHeader = ({ products, activeIndex }) => {
  return (
    <thead>
      <tr className="ph3 bg-white">
        {/* Empty first cell above leftmost column */}
        <td className="fw6 ph3 pv3 hairline-1 br bb z-1 top-0 sticky bg-white"></td>
        {products &&
          products.map((product, productIx) => {
            const hidden = activeIndex !== productIx;

            return (
              <HeaderCell key={product.id} hidden={hidden} product={product} />
            );
          })}
      </tr>
    </thead>
  );
};

export default TableHeader;
